import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEBiotechnologyCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Biotechnology",
    shortName: "B.E. Biotech",
    duration: "4 years",
    description: "Engineering program combining biological sciences with engineering principles for industrial and medical applications",
    overview: "Bachelor of Engineering in Biotechnology (B.E. Biotech) is a 4-year undergraduate program that integrates biology, chemistry, and engineering to develop products and processes for healthcare, agriculture, and industry. This course covers genetic engineering, bioprocessing, pharmaceutical biotechnology, and environmental applications, preparing students for careers in the rapidly growing biotechnology sector.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Biology/Biotechnology strongly preferred",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Biology",
          "Engineering Graphics",
          "Introduction to Biotechnology"
        ]
      },
      {
        year: 2,
        subjects: [
          "Biochemistry",
          "Microbiology",
          "Cell Biology",
          "Organic Chemistry",
          "Thermodynamics",
          "Biostatistics"
        ]
      },
      {
        year: 3,
        subjects: [
          "Genetic Engineering",
          "Bioprocess Engineering",
          "Molecular Biology",
          "Immunology",
          "Bioinformatics",
          "Environmental Biotechnology"
        ]
      },
      {
        year: 4,
        subjects: [
          "Pharmaceutical Biotechnology",
          "Industrial Biotechnology",
          "Biomedical Engineering",
          "Regulatory Affairs",
          "Project Work",
          "Industrial Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Biotechnology Engineer",
        "Research Scientist",
        "Bioprocess Engineer",
        "Quality Control Analyst",
        "Product Development Manager",
        "Regulatory Affairs Specialist",
        "Bioinformatics Specialist",
        "Clinical Research Associate",
        "Patent Analyst",
        "Technical Writer"
      ],
      industries: [
        "Pharmaceutical Companies",
        "Biotechnology Firms",
        "Agricultural Biotechnology",
        "Food and Beverage Industry",
        "Environmental Consulting",
        "Research Institutions",
        "Government Laboratories",
        "Healthcare Organizations",
        "Bioinformatics Companies",
        "Patent and Legal Firms"
      ],
      averageSalary: "₹5-10 LPA (Fresher), ₹15-40 LPA (Experienced)",
      topRecruiters: [
        "Biocon, Dr. Reddy's",
        "Cipla, Sun Pharma",
        "Glenmark, Lupin",
        "Indian Immunologicals",
        "CSIR Labs, ICMR",
        "Monsanto, Bayer CropScience"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "VIT University",
        location: "Vellore",
        fees: "₹7,83,000",
        ranking: "NIRF Ranking: 15"
      },
      {
        name: "SRM Institute of Science and Technology",
        location: "Chennai",
        fees: "₹12,00,000",
        ranking: "NIRF Ranking: 41"
      },
      {
        name: "Anna University (CEG)",
        location: "Chennai",
        fees: "₹2,00,000",
        ranking: "NIRF Ranking: 35"
      },
      {
        name: "Kumaraguru College of Technology",
        location: "Coimbatore",
        fees: "₹4,00,000",
        ranking: "NAAC A+ Grade"
      }
    ],

    skills: [
      "Genetic Engineering Techniques",
      "Bioprocess Design",
      "Laboratory Techniques",
      "Bioinformatics Software",
      "Data Analysis",
      "Regulatory Knowledge",
      "Research Methodology",
      "Scientific Writing",
      "Project Management",
      "Quality Assurance"
    ],

    futureScope: "Excellent growth potential with advancing gene therapy, personalized medicine, agricultural biotechnology, and India's growing biotechnology sector receiving significant investment.",

    faqs: [
      {
        question: "What's the difference between Biotechnology and Biomedical Engineering?",
        answer: "Biotechnology focuses on using living organisms for industrial processes, while Biomedical Engineering emphasizes medical devices and healthcare technology applications."
      },
      {
        question: "Are there research opportunities in Biotechnology?",
        answer: "Yes, excellent research opportunities in government labs like CSIR, ICMR, agricultural universities, and private R&D companies developing new biotechnology products."
      },
      {
        question: "Can I work in pharmaceutical companies?",
        answer: "Yes, pharmaceutical companies actively recruit biotechnology engineers for drug development, quality control, regulatory affairs, and bioprocess engineering roles."
      },
      {
        question: "What about higher studies options?",
        answer: "Great options for M.S./Ph.D. in Biotechnology, Bioinformatics, or related fields at top Indian institutes or international universities, especially in the US and Europe."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEBiotechnologyCoursePage;
